import {
  SlideAction,
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import React, { useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useParams } from 'react-router';
import { Issue } from '../../issues/components/issue';
import { HeaderResetButton } from '../../shared/components/headerResetButton';
import ActivityEditLabels from './activity-edit-label';
import { ActivityEditColumn } from './activityEditColumn';

export const ActivityEdit = () => {
  const { issueId = '' } = useParams();
  const resetLabelsRef = useRef<(() => void) | undefined>(undefined);
  const resetFormRef = useRef<(() => void) | undefined>(undefined);
  const [selectedLabels, setSelectedLabels] = useState<
    Array<{ id: string; name: string }> | undefined
  >(undefined);
  const [isLabelsPanelOpen, setIsLabelsPanelOpen] = useState(false);
  const backGuardRef = useRef<((onProceed: () => void, onCancel?: () => void) => void) | null>(null);

  const backButtonGuard = (): Promise<boolean> => {
    if (isLabelsPanelOpen) {
      setIsLabelsPanelOpen(false);
      return Promise.resolve(false);
    }
    return new Promise<boolean>((resolve) => {
      if (!backGuardRef.current) {
        resolve(true);
        return;
      }
      backGuardRef.current(
        () => resolve(true),
        () => resolve(false)
      );
    });
  };

  const leftColumn = {
    title: 'activities.detail.title',
    showHeader: false,
    showBackButton: false,
    disableScroll: true,
    mainComponent: <Issue isComingFromActivities onBackPressGuard={backButtonGuard} />,
  };

  const rightColumn = {
    title: 'issue.menu.edit',
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    backButtonGuard,
    mainComponent: (
      <ActivityEditColumn
        selectedLabels={selectedLabels}
        onLabelsChange={setSelectedLabels}
        resetRef={resetFormRef}
        backGuardRef={backGuardRef}
        onOpenLabelsPanel={() => setIsLabelsPanelOpen(true)}
      />
    ),
    headerComponent: (
      <View style={styles.headerResetButton}>
        <HeaderResetButton onReset={() => resetFormRef.current?.()} />
      </View>
    ),
    disableScroll: true,
  };

  const thirdColumn = isLabelsPanelOpen
    ? {
        title: 'issue.new.labels',
        mainComponent: (
          <ActivityEditLabels
            issueId={issueId}
            selectedLabels={selectedLabels ?? []}
            onLabelsChange={setSelectedLabels}
            resetRef={resetLabelsRef}
          />
        ),
        headerComponent: (
          <View style={styles.headerResetButton}>
            <HeaderResetButton
              onReset={() => resetLabelsRef.current?.()}
            />
          </View>
        ),
        showBackButton: true,
        onBackButtonPress: () => setIsLabelsPanelOpen(false),
        disableScroll: true,
      }
    : undefined;

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      thirdColumn={thirdColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const styles = StyleSheet.create({
  headerResetButton: {
    marginRight: 8
  },
});
